import contenttype from '../templates/contenttype';
export default class Enlightenpublications {
  constructor(el) {
    this.el = el;
    this.feed = this.el.dataset.feed;
    this.items = this.el.dataset.items || 5;
    this.dataurl = `/feeds/rss/xml2json.html?url=${this.feed}`;
    this.getdata();
  }

  getdata() {
    return fetch(this.dataurl)
      .then((response) => response.json())
      .then((data) => this.appenddata(data.rss.channel.item));
  }

  appenddata(data) {
    let years = new Set();
    data.forEach((item) => {
      let date = new Date(item.pubDate);
      years.add(date.getFullYear());
    });
    [...years].forEach((year) => {
      this.el.insertAdjacentHTML('beforeend', `<h2>${year}</h2>`);
      const filteredbyyear = data.filter((item) => {
        let datayear = new Date(item.pubDate);
        return year === datayear.getFullYear();
      });
      filteredbyyear.forEach((item) => {
        let date = new Date(item.pubDate);
        const months = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        this.el.insertAdjacentHTML(
          'beforeend',
          contenttype.card({
            content: `
                               <p><strong>${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}</strong></p>
                               <p>${item.description}</p>
                               `,
            heading: item.title,
            link: item.link,
          })
        );
      });
    });
  }
}
